import { AnomalyEventType, IAnomalyEvent, IMetricAnomalyEvent } from "@edgetier/watchtower-types";
import { formatUnderscoreName } from "utilities/format-underscore-name";

/**
 * Figure out the main metrics in an anomly.
 * @param anomalyEvents Events in the current anomaly.
 * @returns             The metric names in the anomaly.
 */
export const getMetricNames = (anomalyEvents: IAnomalyEvent[]) => {
    return anomalyEvents
        .filter(({ anomalyEventType }) => anomalyEventType === AnomalyEventType.New)
        .filter((anomalyEvent): anomalyEvent is IMetricAnomalyEvent => "metric" in anomalyEvent.details)
        .map(({ details }) => formatUnderscoreName(details.metric));
};
